export default __webpack_public_path__ + "static/media/japantrad2.1ce261fc.png";